import { memo, useCallback } from "react";

import { Button } from "@/components/ui/button/button";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog/dialog";

import { MaskCreditInfo, PayjpCreditForm } from "./components";

import type { ComponentProps } from "react";

type Props = {
	isValid: boolean;

	expired: string;
	last4: string;
	canEdit: boolean;
	onChangeCanEdit: (value: boolean) => void;
	onSetTargetElement: (element: HTMLElement) => void;
	onChangeHasPayjpValidation: (hasError: boolean) => void;
	onChangeCardHolderName: (value: string) => void;
	onUpdate: () => void;

	open: boolean;
	handleOpenChange: (open: boolean) => void;
};

export const SettingsPaymentCreditMainDialog = memo(
	({
		isValid,
		expired,
		last4,
		canEdit,
		onChangeCanEdit,
		onChangeHasPayjpValidation,
		onChangeCardHolderName,
		onSetTargetElement,
		onUpdate,

		open,
		handleOpenChange,
	}: Props) => {
		const handleChangeCanEdit = useCallback(() => {
			onChangeCanEdit(!canEdit);
		}, [canEdit, onChangeCanEdit]);

		const disabled = !isValid;
		const variant: ComponentProps<typeof Button>["variant"] = isValid ? "default" : "disabled";

		return (
			<Dialog open={open} onOpenChange={handleOpenChange}>
				<DialogContent className="max-w-screen-tablet">
					<DialogHeader>クレジットカード設定</DialogHeader>

					<div className="font-semibold text-brand">
						<p>クレジットカード情報が登録されていません。</p>
						<p>購入前にクレジットカード情報の登録をお願いします。</p>
					</div>

					<div className="relative w-full py-8">
						<div className="flex-1">
							{canEdit ? (
								<PayjpCreditForm
									onChangeHasPayjpValidation={onChangeHasPayjpValidation}
									onSetTargetElement={onSetTargetElement}
									onChangeCardHolderName={onChangeCardHolderName}
								/>
							) : (
								<MaskCreditInfo last4={last4} expired={expired} />
							)}
						</div>
						<div className="absolute right-0 top-0">
							{canEdit ? (
								<img
									onClick={handleChangeCanEdit}
									className="cursor-pointer"
									src="/assets/icon/editor/edit_off.svg"
									alt=""
								/>
							) : (
								<img
									onClick={handleChangeCanEdit}
									className="cursor-pointer"
									src="/assets/icon/editor/create.svg"
									alt=""
								/>
							)}
						</div>
					</div>
					<div className="flex justify-center">
						<Button type="button" size="xl" variant={variant} disabled={disabled} onClick={onUpdate}>
							保存
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		);
	},
);
SettingsPaymentCreditMainDialog.displayName = "SettingsPaymentCreditMainDialog";
